<rt-dialog-header [heading]="'rti.gfea.name' | translate">
  {{ 'rti.gfea.edit_posting.duplicate_offer.subtitle' | translate }}
</rt-dialog-header>
<rt-dialog-body layout-vertical>
  <div
    [innerHTML]="
      'rti.gfea.edit_posting.duplicate_offer.description'
        | translate: { original_job_title: dialogData.duplicateOffer.title }
    "
  ></div>
</rt-dialog-body>
<rt-dialog-footer>
  <rt-button variant="plain" (click)="close()">
    {{ 'rti.common.cancel' | translate }}
  </rt-button>

  <rt-button variant="primary" (click)="openDuplicateOffer()">
    {{ 'rti.gfea.edit_posting.duplicate_offer.open_main_job' | translate }}
  </rt-button>
</rt-dialog-footer>
